export const ADD_TO_CART = "feature/Cart/ADD_TO_CART";
export const REMOVE_FROM_CART = "feature/Cart/REMOVE_FROM_CART";
export const EMPTY_CART = "feature/Cart/EMPTY_CART";
export const FETCH_CART = "feateure/Cart/FETCH_CART";
